import React from 'react';
import { ImageGalleryImage } from '../platformui/ImageGallery';
import withLazyLoad from '../platformui/Containers/withLazyLoad';
import withSrcSets from '../platformui/Containers/withSrcSets';
import withSensitiveImage from '../platformui/Containers/withSensitiveImage';
import ImageBlock from '../platformui/ImageBlock';
import * as Render from '../platformui/Base/Render';
import Linklist from '../platformui/Linklist';

const ImageBlockWithSrcSets = withLazyLoad(
  withSrcSets(withSensitiveImage(ImageBlock))
);

const SlideshowImageBlock = (props) => (
  <ImageGalleryImage
    {...props}
    ReadMoreText={props.CurrentPageProps.Content.Translations.readmore}
    ReadLessText={props.CurrentPageProps.Content.Translations.readless}
    Image={
      <ImageBlockWithSrcSets
        {...props}
        CurrentPageProps={props.CurrentPageProps}
        ImageText={null}
        Modifiers={{ 'c-imageblock--is-gallery': true }}
      />
    }
    ImageText={props.Photographer}
    ImageGalleryHeading={Render.PropertyAsHTML(
      props.ImageHeading,
      'ImageHeading'
    )}
    ImageGalleryText={Render.PropertyAsHTML(props.ImageText, 'ImageText')}
    ImageGalleryLinks={
      !props.ImageLinks && !props.CurrentPageProps.IsEditMode
        ? null
        : Render.Property(<Linklist Links={props.ImageLinks} />, 'ImageLinks')
    }
  />
);

export default SlideshowImageBlock;